import { useDialog } from 'primevue/usedialog'
import AppAlert from '~/components/Modals/AppAlert.vue'
import { h, markRaw } from 'vue'
import AppAlertFooter from '~/components/Modals/AppAlertFooter.vue'

export function useShowAlert(): (
    header: string,
    body: string,
    dangerousHtml?: boolean
) => Promise<void> {
    const dialog = useDialog()

    return (header: string, body: string, dangerousHtml?: boolean) => {
        return new Promise(resolve => {
            const dialogRef = dialog.open(
                () => h(AppAlert, { body, dangerousHtml }),
                {
                    props: {
                        header,
                        style: {
                            width: '40rem'
                        },
                        modal: true
                    },
                    templates: {
                        footer: markRaw(
                            h(AppAlertFooter, {
                                onClose: () => dialogRef.close()
                            })
                        )
                    },
                    onClose: () => {
                        resolve()
                    }
                }
            )
        })
    }
}
